/* ============================================================
   KN — live stock check for product cards

   Liquid renders the correct stock state at request time, but the HTML a
   shopper actually receives can come from Shopify's CDN cache, from the
   browser cache, or from the back-forward cache, so a card can sit a few
   minutes behind the admin. This script asks Shopify for each product's
   current availability through the product JSON endpoint, bypassing the
   browser cache, and repaints any card that disagrees.

   Runs on first load, every time the tab regains focus, and on
   back-forward restore. Covers the collection grid (.kn-card), the
   homepage best sellers (.prod), the cross-sell row (.pcard) and the
   compact "bought with" list (.bwith__row).

   Only the sold-out / available flip is corrected here. The exact
   "Only N left" count is not exposed by the public endpoint, so a low
   badge is left as rendered unless the product has sold out entirely.
   ============================================================ */
(function () {
  "use strict";

  var SURFACES = [
    { card: ".kn-card",     media: ".kn-card__media", btn: ".kn-card__add[data-add-variant]", attr: "data-add-variant", buyLabel: "Quick Add" },
    { card: ".knlux .prod", media: ".ph",             btn: null },
    { card: ".pcard",       media: ".pcard__media",   btn: ".pcard__add[data-variant]",      attr: "data-variant",     buyLabel: "Quick Add" },
    { card: ".bwith__row",  media: null,              btn: ".bwith__add[data-variant]",      attr: "data-variant",     buyLabel: "Add" }
  ];

  function handleOf(card) {
    var a = card.matches("a[href]") ? card : card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = (a.getAttribute("href") || "").match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function fetchProduct(handle) {
    return fetch("/products/" + handle + ".js", { cache: "no-store", headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function firstAvailable(p) {
    if (!p.variants) return null;
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i];
    return null;
  }

  function paint(card, s, p) {
    var out = !p.available;
    var media = s.media ? (card.matches(s.media) ? card : card.querySelector(s.media)) : null;

    card.classList.toggle("is-out", out);

    if (media) {
      var outBadges = media.querySelectorAll(".knstock--out");
      if (out) {
        if (!outBadges.length) {
          /* A low-stock badge cannot coexist with sold out. */
          media.querySelectorAll(".knstock").forEach(function (n) { n.parentNode.removeChild(n); });
          var b = document.createElement("span");
          b.className = "knstock knstock--out";
          b.textContent = "Sold Out";
          media.appendChild(b);
        }
      } else {
        outBadges.forEach(function (n) { n.parentNode.removeChild(n); });
      }
    }

    if (!s.btn) return;
    var btn = card.querySelector(s.btn);
    if (!btn) return;

    var label = btn.textContent.trim();
    if (out) {
      if (!btn.dataset.knLabel && /^(quick add|add)$/i.test(label)) btn.dataset.knLabel = label;
      btn.disabled = true;
      btn.textContent = "Sold Out";
    } else {
      if (label === "Sold Out" || label === "Just sold out") {
        btn.disabled = false;
        btn.textContent = btn.dataset.knLabel || s.buyLabel;
      }
      /* Point the button at a variant that can actually be bought. A card
         rendered while sold out carries the first variant, which may still
         be out even after a partial restock of the others. */
      var v = firstAvailable(p);
      if (v && s.attr) btn.setAttribute(s.attr, String(v.id));
    }
  }

  function run() {
    var jobs = {};
    SURFACES.forEach(function (s) {
      document.querySelectorAll(s.card).forEach(function (card) {
        var h = handleOf(card);
        if (!h) return;
        (jobs[h] = jobs[h] || []).push({ card: card, s: s });
      });
    });
    var handles = Object.keys(jobs);
    if (!handles.length) return Promise.resolve();
    return Promise.all(handles.map(function (h) {
      return fetchProduct(h).then(function (p) {
        if (!p || typeof p.available !== "boolean") return;
        jobs[h].forEach(function (j) { paint(j.card, j.s, p); });
      });
    }));
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
  document.addEventListener("visibilitychange", function () { if (!document.hidden) run(); });
  window.addEventListener("pageshow", function (e) { if (e.persisted) run(); });

  window.KNStockLive = { refresh: run };

  /* ------------------------------------------------------------
     Collection grid Quick Add.
     The grid section's own handler reports "Added" whenever any
     response comes back, including a 422 for a variant that has just
     sold out. Take the click here in the capture phase and route it
     through the shared cart API, which rejects on a refused add, then
     re-check the card so the button turns into Sold Out for real.
     ------------------------------------------------------------ */
  document.addEventListener("click", function (e) {
    var b = e.target.closest(".kn-card__add[data-add-variant]");
    if (!b || b.disabled || !window.KNCart || !window.KNCart.add) return;
    e.stopPropagation();
    e.preventDefault();
    var id = parseInt(b.getAttribute("data-add-variant"), 10);
    var orig = b.textContent;
    b.disabled = true;
    b.textContent = "Adding…";
    window.KNCart.add(id, 1).then(function () {
      b.textContent = "Added ✓";
      window.KNCart.open();
      setTimeout(function () { b.textContent = orig; b.disabled = false; }, 1500);
    }).catch(function () {
      b.textContent = "Just sold out";
      run();
      setTimeout(function () {
        if (b.textContent === "Just sold out") { b.textContent = orig; b.disabled = false; }
      }, 2200);
    });
  }, true);
})();
